<template>
  <el-menu class="navbar" mode="horizontal">
    <!-- 其他菜单项 -->
    
    <!-- 登出按钮 -->
    <el-menu-item index="logout" class="logout-menu-item" @click="handleLogout">
      退出登录
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  components: {},
  methods: {
    handleLogout() {
      window.localStorage.removeItem("token")
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
}

.logout-menu-item {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue